<template>
    <div class="field grid">
        <label for="Shipment_No" class="col-4 font-bold">{{$t("shipment_no")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span class="pre">{{data.Shipment_No}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Order_No" class="col-4 font-bold">{{$t("order_no")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span class="pre">{{data.Order_No}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="SAP_No" class="col-4 font-bold">{{$t("sap_no")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span class="pre">{{data.SAP_No}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Loading" class="col-4 font-bold">{{$t("loading")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.Loading_Destination_From_Name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div class="field grid">
        <label for="Destination" class="col-4 font-bold">{{$t("destination")}}</label>
        <span class="col-1 md-1">:</span>
        <div class="col-7 md-7">
            <span>{{data.Loading_Destination_To_Name}}</span>
        </div>
        <Divider class="m-0" />
    </div>
    <div v-if="showDetailed">
        <div class="field grid">
            <label for="Stuffing_Date" class="col-4 font-bold">{{$t("stuffing_date")}}</label>
            <span class="col-1 md-1">:</span>
            <div class="col-7 md-7">
                <span>{{$formatDate(data.Stuffing_Date_From) + " - " + $formatDate(data.Stuffing_Date_To)}}</span>
            </div>
            <Divider class="m-0" />
        </div>
        <div class="field grid">
            <label for="Shipment_Type" class="col-4 font-bold">{{$t("shipment_type")}}</label>
            <span class="col-1 md-1">:</span>
            <div class="col-7 md-7">
                <span>{{data.shipment_type_name}}</span>
            </div>
            <Divider class="m-0" />
        </div>
        <div class="field grid">
            <label for="Truck_Type_Name" class="col-4 font-bold">{{$t("truck_type")}}</label>
            <span class="col-1 md-1">:</span>
            <div class="col-7 md-7">
                <span>{{data.Truck_Type_Name}}</span>
            </div>
            <Divider class="m-0" />
        </div>
        <div class="field grid">
            <label for="Customer_Vendor_Name" class="col-4 font-bold">{{$t("customer_vendor")}}</label>
            <span class="col-1 md-1">:</span>
            <div class="col-7 md-7">
                <span>{{data.Customer_Name}}</span>
            </div>
            <Divider class="m-0" />
        </div>
        <div class="field grid">
            <label for="Customer_Vendor_Address" class="col-4 font-bold">{{$t("address")}}</label>
            <span class="col-1 md-1">:</span>
            <div class="col-7 md-7">
                <span>{{ data.Delivery_Address ? data.Delivery_Address : data.Customer_Vendor_Address }}</span>
            </div>
            <Divider class="m-0" />
        </div>
    </div>
    
    <Fieldset legend="Drivers" v-if="data.Drivers != null && data.Drivers.length > 0 && showDrivers">
        <DataTable :loading="!data" :value="data.Drivers ? data.Drivers : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
            <Column field="Driver_Name" :header="$t('driver')" key="Driver_Name">  
            </Column>
            <Column field="License_No" :header="$t('license_no')" key="License_No">
            </Column>
            <Column field="Phone" :header="$t('phone')" key="Phone">
            </Column>
            <Column field="Vehicle_Name" :header="$t('vehicle_no')" key="Vehicle_Name">
            </Column>
            <Column field="Container_No" :header="$t('container_no')" key="Container_No">
            </Column>
        </DataTable>
    </Fieldset>

</template>
<script>

export default {
    props:{
        data:{
            type:Object,
            default: null
        },
        showDetailed:{
            type:Boolean,
            default: true
        },
        showDrivers:{
            type: Boolean,
            default: true
        }
    },
    computed:{
        documentNo(){
            var data = this.data;
            return data ? (data.Order_No ? data.Order_No + " / " + data.SAP_No : data.Document_No) : "";
        }
    }
}
</script>